import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import "./BannerCarousel.css";

export default function BannerCarousel({ banners }) {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const go = useCallback(
    (index) => {
      if (isTransitioning || index === current) return;
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrent(index);
        setIsTransitioning(false);
      }, 400);
    },
    [current, isTransitioning]
  );

  const next = useCallback(() => {
    go((current + 1) % banners.length);
  }, [current, banners.length, go]);

  useEffect(() => {
    if (banners.length <= 1) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [banners.length, next]);

  if (!banners || banners.length === 0) {
    return (
      <div className="banner-fallback">
        <div className="banner-fallback-inner">
          <p className="banner-tag">Ласкаво просимо</p>
          <h1>Маленька Історія</h1>
          <p className="banner-subtitle">Книжки та іграшки для ваших малюків</p>
          <Link to="/catalog" className="btn-primary">
            Переглянути каталог
          </Link>
        </div>
      </div>
    );
  }

  const banner = banners[current];
  const imageUrl = banner.image?.startsWith("http")
    ? banner.image
    : `${banner.image}`;

  return (
    <div className="banner-carousel">
      <div className={`banner-slide ${isTransitioning ? "fade-out" : "fade-in"}`}>
        <img src={imageUrl} alt={banner.title || "Банер"} />
        <div className="banner-overlay" />
        <div className="banner-content">
          {banner.title && <h1>{banner.title}</h1>}
          {banner.subtitle && <p>{banner.subtitle}</p>}
          <Link to="/catalog" className="btn-primary">
            Переглянути каталог
          </Link>
        </div>
      </div>

      {banners.length > 1 && (
        <>
          <button
            className="banner-arrow left"
            onClick={() => go((current - 1 + banners.length) % banners.length)}
          >
            ‹
          </button>
          <button className="banner-arrow right" onClick={next}>
            ›
          </button>
          <div className="banner-dots">
            {banners.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === current ? "active" : ""}`}
                onClick={() => go(i)}
                aria-label={`Слайд ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
